import useWeekPlanExcluderControl from "./WeekPlanExcluder.control";
import styles from "./WeekPlanExcluder.module.scss";
import { useIntl } from "react-intl";
import Checkbox from "@components/global/new/Checkbox/Checkbox";
import Option from "../Option/Option";

interface IWeekPlanExcluderProps {

}

function WeekPlanExcluder(
  props: IWeekPlanExcluderProps
): JSX.Element {

  const { formatMessage } = useIntl();
  const control = useWeekPlanExcluderControl();

  if (!control.isShowWeekPlan) return <></>;

  return (
    <div className={styles.weekDayPeriods}>
      <div className={styles.weekDayPeriods_title}>
        {control.disabled && (<>
          {formatMessage({ id: "manage.plan_info.interval" })}
          <span className={styles.planTitle}>{control.weekDayPeriods?.dayIndex}</span>
        </>)}
        {!control.disabled && (
          <div>
            <Checkbox
              checked={control.isWeekPlanUsed}
              onClick={control.useWeekPlanChanged}
            />
            {formatMessage({ id: "manage.plan_info.interval" })}
            <span className={styles.planTitle}>{control.weekDayPeriods?.dayIndex}</span>
          </div>
        )}
      </div>
      <div className={styles.readOnlyPeriods__container}>
        {control.weekDayPeriods?.range.map((wdp, i) => (
          <div className={styles.readOnlyPeriods} key={i}>
            <Option
              id={i}
              rowNum={i}
              isError={false}
              option={wdp.time}
              disabled={true}
              crossed={!control.isWeekPlanUsed}
              onOpenChanged={(value) => {

              }}
              onDeletePeriod={(id) => {

              }}
            />
          </div>
        ))}
      </div>
    </div>
  );

}

export default WeekPlanExcluder;